export class InterestedEmail {
    emailAddress: string;

    constructor(emailAddress: string) {
        this.emailAddress = emailAddress;
    }
}